import React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios'
import VideoCard from '../presentational/VideoCard'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles(theme => ({
    loader: {
        textAlign: 'center',
    },
}));
export default function VideoList(props) {
    const classes = useStyles();
    const [videos, setVideos] = useState(null)
    useEffect(() => {
        console.log(props.authToken)
        console.log(`Fetching (POST) '/law/api/online-cle/OnlineCLE_Videos'`);
        axios.post(`/law/api/online-cle/OnlineCLE_Videos`, {
            Token: props.authToken
        })
            .then(res => {
                console.log(res.data)
                setVideos(res.data)
            })
    }, [props.authToken])

    return (
        <div>
            {videos != null ?
                videos.length > 0 ?
                    videos.map((video, index) => (
                        <VideoCard authToken={props.authToken} timestamp={video.Timestamp} vid={video.VideoId} title={video.Title} CreditType={video.Name} CLECredit={video.CLECredit} ExpirationDate={video.ExpirationDate} DateSubmitted={video.DateSubmitted} QuikPayId={video.QuikPayId} VideoLength={video.VideoLength} ReadingMaterialsUrl={video.ReadingMaterialsUrl} Description={video.Description}></VideoCard>
                    ))
                    :
                    <Typography>There are no CLE videos currently available</Typography>
                :
                <Box className={classes.loader}>
                    <Typography variant="h6" component="h2">Getting Online CLE Videos</Typography>
                    <CircularProgress />
                </Box>
            }
        </div>
    );
}